// ** Dropdowns Imports
import UserDropdown from "./UserDropdown"

// ** Third Party Components
import { Sun, Moon } from "react-feather"

// ** Reactstrap Imports
import { NavItem, NavLink } from "reactstrap" 
import { getUserData } from '@utils'

const NavbarUser = (props) => {
  // ** Props
  const { skin, setSkin } = props 
  const user = getUserData() 
  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === "dark") {
      return <Sun className="ficon" onClick={() => setSkin("light")} />
    } else {
      return <Moon className="ficon" onClick={() => setSkin("dark")} />
    }
  }
  return ( 
    <>
       <div className="align-items-center" style={{ display: 'flex', fontSize: '22px' }}>
        <span style={{ color: '#9d9d9d' }}>Mobile Buy-Back</span>
      </div> 
      <ul className="nav navbar-nav align-items-center ms-auto">
        <NavItem className="d-none d-lg-block">
          <NavLink className="nav-link-style">
            <ThemeToggler />
          </NavLink>
        </NavItem>
        <NavItem className="d-none d-lg-block">
          <p className="mb-0" style={{textAlign: 'right', fontWeight: '600'}}>{user && user.user_name ? user.user_name : ''}</p>
          <p className="mb-0">{user && user.lastLogin ? user.lastLogin : ''}</p>
        </NavItem>
        <UserDropdown />
      </ul>
    </>
  )
}
export default NavbarUser
